import React from 'react'
import * as pages from '../../constants/pages'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { withStyles } from '@material-ui/core/styles'

export default ({ currentPage, onChange }) => {
	// prevent react from complaining if currentPage isn't a tab
	const idx = [pages.FILTER, pages.SELECTION, pages.HELP].indexOf(currentPage);
	if(idx === -1){
		currentPage = false;
	}

	return (
		<Tabs value={currentPage} onChange={onChange}>
			<StyledTab label="Visa" value={pages.FILTER} />
			<StyledTab label="Urval" value={pages.SELECTION} />
			<StyledTab label="Hjälp" value={pages.HELP} />
		</Tabs>
	)
}

const tabStyles = {
	root: {
		minWidth: 0,
		flex: 1,
		maxHeight: '200px',
		overflowY: 'auto',
		owverflowX: 'auto'
		// textShadow: '1px 1px 2px #000000'
	}
}

const StyledTab = withStyles(tabStyles)(Tab)



// WEBPACK FOOTER //
// ./src/components/Header/Menu.js